import { Button, Modal, Table, Row, Col, Alert } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';

import { useAuth } from "../../contexts/auth-context";
import {
  getTransactionsWithUnpaidReferrerFees,
  sendTransactionMetamask,
  getSenderReceiverCryptoAddress
} from '../../rest/admin/transactions';
import { metamaskSendUSDC, checkMetaMaskAndNetwork } from '../../helpers';

import './styles/AdminReferrers.css';

const PUNKYPAY_ALLOWED_METAMASK_PAYMENT_ADDRESS = ['0x49415ec16D27F2BD0DC4125C15c98522cf4FcdB7'];

const AdminReferrers = (props) => {
  const { transactions = [], inProgress = false } = props;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();
  const loginEmail = auth.currentUser?.email;

  const cryptoAccount = useSelector(state => state.cryptoAccount.account);
  const signedInWithMetamask = cryptoAccount.data?.exchange?.toLowerCase() === 'metamask';

  const fetchUnpaidReferrerFees = async () => {
    try {
      const response = await getTransactionsWithUnpaidReferrerFees();
      console.log('REFERRER RESPONSE --->', response);
      if (response.data) {
        setData(response.data);
      }
      setLoadingData(false);
    } catch (error) {
      // If the error response indicates an expired token, sign out the user
      if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
        auth.signOut();
      }

      setLoadingData(false);
      const errorData = error.response?.data;
      if (errorData?.errorCode) { // This means the error is our customized error from the server
        setError(errorData.message);
        return;
      }

      setError(error.message);
    }
  }

  useEffect(() => {
    const ethusdc_address = cryptoAccount.data?.ethusdc_address;
    if (!signedInWithMetamask) {
      setError("You don't have Metamask Crypto Account registered yet. You won't be able to process any payment until you are signed in to Metamask")
    } else if (!ethusdc_address) {
      setError("Your Metamask Crypto Account with us doesn't have ethusdc address. Please provide one")
    } else {
      checkMetaMaskAndNetwork(ethusdc_address).then(result => {
        if (result.success) {
          console.log("All checks passed. Wallet address:", result.address);
        } else {
          console.error("Check failed:", result.error);
          setError(result.error);
        }
      });
    }
  }, []);

  const handleReferrerPayment = async (recipientEmail, amount, referrerTransactions) => {

    try {
      setLoading(true);
      console.log('amount ====>', amount);

      const senderReceiverAddress = await getSenderReceiverCryptoAddress({ to: recipientEmail, from: loginEmail });

      const sentTo = senderReceiverAddress.data.sent_to_ethusdc_address;
      const sentFrom = senderReceiverAddress.data.sent_from_ethusdc_address;

      if (!sentFrom) {
        setError(`ethusdc address not found for sender "${loginEmail}" to process the request`);
        return;
      }

      if (!sentTo) {
        setError(`ethusdc address not found for recipient "${recipientEmail}" to process the request`);
        return;
      }

      if (!PUNKYPAY_ALLOWED_METAMASK_PAYMENT_ADDRESS.map(adr => adr.toLowerCase()).includes(sentFrom.toLowerCase())) {
        setError(`ethusdc address "${sentFrom}" not part of Punkypay allowed address to process the request`);
        return;
      }

      const responseSendUSDC = await metamaskSendUSDC(sentTo, sentFrom, amount);

      //const responseSendUSDC = { txHash: 'dummyHash', gasInfo: { estimatedCostUSDC: 'dummyEst'} }

      console.log(responseSendUSDC.txHash);
      console.log(responseSendUSDC.gasInfo.estimatedCostUSDC);
      const sendCryptoData = {
        to: recipientEmail,
        amount,
        currency: "USDC",
        network_name: 'ethereum',
        txn_id: responseSendUSDC.txHash,
        gas_cost: responseSendUSDC.gasInfo.estimatedCostUSDC.toString(),
        shortMemo: `$${amount} referrer payment made to ${recipientEmail}`,
        notes: 'Referrer payment made by Punkypay',
        totalAmountUserEntered: amount,
        referrerTransactions,
      };

      console.log('sendCryptoData >>>>>>>>>>>', sendCryptoData)
      const responseSaveInDatabase = await sendTransactionMetamask(sendCryptoData);
      console.log(responseSaveInDatabase)

      if (responseSaveInDatabase) {
        console.log('Transaction Created successfully =>', responseSaveInDatabase.data);
        await fetchUnpaidReferrerFees();
      }
    } catch (error) {
      console.log('Transaction Create: Error =>', error);
      // If the error response indicates an expired token, sign out the user
      if (error.response && error.response.data?.errorCode === 'TOKEN_EXPIRED') {
        auth.signOut();
      }


      // if metamask error
      if (error.code === 4001) {
        setError("Transaction rejected by the user.");
        // Return error information
        return;
      }

      const errorData = error.response?.data;
      if (errorData?.errorCode) { // This means the error is our customized error from the server
        setError(errorData.message);
        return;
      }

      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  const onPay = (record) => {
    setError('');
    console.log('Payment record ==>', record);
    if (!record) {
      setError('No record to process request');
      return;
    }

    handleReferrerPayment(record.referrer, record.amount, record.transactions);
  }

  const columns = [
    {
      title: "Referrer",
      dataIndex: "referrer",
      key: "referrer",
      // fixed: "left",
      width: "200px",
    },
    {
      title: "Amount ($)",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount - b.amount,
      width: "150px",
    },
    // {
    //   title: "Memo",
    //   dataIndex: "memo",
    //   key: "memo",
    //   width: "200px",
    // },
    // {
    //   title: "Transaction Time",
    //   dataIndex: "transactionTime",
    //   key: "transactionTime",
    //   width: "200px",
    // },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      width: "200px",
      render: (_, record) => {
        return (
          <Button
            type="primary"
            style={{ paddingLeft: '30px', paddingRight: '30px' }}
            disabled={loading}
            onClick={() => onPay(record)}
          >
            Pay
          </Button>
        )
      },
    },
  ];

  useEffect(() => {
    fetchUnpaidReferrerFees();
  }, [])


  return (
    <div className="admin-referrer-page">
      <h2 className="text-center">Referrers</h2>
      {
        error && (
          <Row style={{ marginBottom: '20px' }}>
            <Col
              xs={{ span: 24 }}
              md={{ span: 16, offset: 4 }}
              style={{ marginTop: "10px" }}
            >
              <Alert className="text-center" message={error} type="error" />
            </Col>
          </Row>
        )
      }
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: 1024 }}
        loading={loadingData}
      //onRow={onRow}
      />
    </div>
  );
};

export default AdminReferrers;
